export enum ColumnSettings {
  INVOICE_LISTING = 'INVOICE_LISTING',
  CLIENT_LISTING = 'CLIENT_LISTING',
  ORAGANISATION_ENTITY = 'ORAGANISATION_ENTITY',
  PLACEMENT_LISTING = 'PLACEMENT_LISTING',
  CLIENT_ORGANSATIONENTITY = 'CLIENT_ORGANSATIONENTITY',
  CLIENT_CLIENTCONTACT = 'CLIENT_CLIENTCONTACT',
  CLIENT_FEEARRANGEMENT = 'CLIENT_FEEARRANGEMENT',
  CLIENTT_INVOICES = 'CLIENTT_INVOICES',
  CLIENT_CANDIDATEPLACED = 'CLIENT_CANDIDATEPLACED',
  ORAGNISATION_ENTITY_CLIENTS = 'ORAGNISATION_ENTITY_CLIENTS',
  CLOSURE_INVOICES = 'CLOSURE_INVOICES',
  CLOSURE_PLACEMENTS = 'CLOSURE_PLACEMENTS',
  VENDOR_LISTING = 'VENDOR_LISTING',
  LEAD_LISTING = 'LEAD_LISTING',
}

export default ColumnSettings;
